// extracted by mini-css-extract-plugin
module.exports = {"container":"FullscreenExitButton_container__E3jAN"};